module.exports = __webpack_public_path__ + "img/macro_icon.1b59d2f1.png";